/* OB Cycling landing — behaviour for sections/ob-cy-*.liquid (reveal, season switch, size finder, kit builder). Runs once. */
(function () {
  if (window.__obcy) return;
  window.__obcy = true;
  var doc = document.documentElement;
  doc.classList.add('obcy-js');

  /* Returns HTML: the store's dirham symbol (.po-aed, same as the product cards) for AED, else the ISO code. */
  function money(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var cur = window.obcyCur || 'AED';
    if (cur === 'AED') return '<bdi dir="ltr"><span class="po-aed" aria-hidden="true"></span><span class="obcy-vh">AED </span>' + s + '</bdi>';
    return '<bdi dir="ltr">' + cur + ' ' + s + '</bdi>';
  }

  /* Hide same-page #links whose target section is missing or hidden (e.g. no products yet, other season). */
  function deadLinks() {
    /* compare paths without the locale root (/ar/…), since link settings are stored without it */
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
    function norm(p) { p = p.replace(/\/$/, ''); return root && p.indexOf(root + '/') === 0 ? p.slice(root.length) : p; }
    var here = norm(location.pathname);
    document.querySelectorAll('.obcy a[href*="#"]').forEach(function (a) {
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (norm(u.pathname) !== here || !u.hash) return;
      var t = document.getElementById(decodeURIComponent(u.hash.slice(1)));
      var ok = !!t && getComputedStyle(t).display !== 'none' && !t.closest('[hidden]');
      a.classList.toggle('obcy-dead', !ok);
    });
  }

  /* reveal on scroll */
  function reveal(root) {
    var els = (root || document).querySelectorAll('.obcy [data-obcy-r]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e, i) { e.style.transitionDelay = Math.min((e.dataset.obcyD || 0) * 1, 400) + 'ms'; io.observe(e); });
  }

  /* season switch (hero buttons) */
  function setSeason(s) {
    doc.setAttribute('data-obcy-season', s);
    document.querySelectorAll('[data-obcy-season-btn]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.obcySeasonBtn === s ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-obcy-season-btn]');
    if (b) { setSeason(b.dataset.obcySeasonBtn); reveal(); deadLinks(); }
    var v = e.target.closest('[data-obcy-vid]');
    if (v) {
      var vid = v.closest('.obcy-hero__slide').querySelector('video');
      if (vid) { if (vid.paused) { vid.play(); v.setAttribute('aria-pressed', 'false'); } else { vid.pause(); v.setAttribute('aria-pressed', 'true'); } }
    }
  });

  /* size finder */
  function initSize(root) {
    root.querySelectorAll('[data-obcy-size]').forEach(function (box) {
      if (box.__i) return; box.__i = true;
      var rows = []; try { rows = JSON.parse(box.querySelector('[data-obcy-size-rows]').textContent); } catch (e) {}
      var fit = 'snug';
      var out = box.querySelector('[data-obcy-size-out]');
      var note = box.querySelector('[data-obcy-size-note]');
      box.querySelectorAll('[data-obcy-fit]').forEach(function (b) {
        b.addEventListener('click', function () {
          fit = b.dataset.obcyFit;
          box.querySelectorAll('[data-obcy-fit]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      box.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var h = parseFloat(box.querySelector('[name="h"]').value), w = parseFloat(box.querySelector('[name="w"]').value);
        if (!h || !w || !rows.length) return;
        var idx = rows.length - 1;
        for (var i = 0; i < rows.length; i++) { if (h <= rows[i].h && w <= rows[i].w) { idx = i; break; } }
        if (fit === 'relaxed' && idx < rows.length - 1) idx++;
        if (fit === 'race' && idx > 0 && (h <= rows[idx - 1].h + 2) && (w <= rows[idx - 1].w + 2)) idx--;
        out.textContent = rows[idx].s;
        out.classList.remove('pop'); void out.offsetWidth; out.classList.add('pop');
        if (note) note.hidden = false;
      });
    });
  }

  /* kit builder */
  function initKit(root) {
    root.querySelectorAll('[data-obcy-kit]').forEach(function (kit) {
      if (kit.__i) return; kit.__i = true;
      var sum = kit.querySelector('[data-obcy-kit-lines]');
      var tot = kit.querySelector('[data-obcy-kit-total]');
      var err = kit.querySelector('[data-obcy-kit-err]');
      function render() {
        var html = '', t = 0;
        kit.querySelectorAll('[data-obcy-step]').forEach(function (st) {
          var on = st.querySelector('[aria-pressed="true"][data-v]');
          if (!on) return;
          var img = st.querySelector('[data-obcy-step-img]');
          if (img && on.dataset.img) { img.src = on.dataset.img; img.alt = on.dataset.t; }
          t += parseInt(on.dataset.p, 10);
          html += '<div class="obcy-sum__ln"><span></span><b>' + money(parseInt(on.dataset.p, 10)) + '</b></div>';
        });
        sum.innerHTML = html;
        var i = 0;
        kit.querySelectorAll('[data-obcy-step]').forEach(function (st) {
          var on = st.querySelector('[aria-pressed="true"][data-v]');
          if (!on) return;
          sum.children[i].firstChild.textContent = on.dataset.t; i++;
        });
        tot.innerHTML = money(t);
      }
      kit.querySelectorAll('[data-obcy-step]').forEach(function (st) {
        st.querySelectorAll('[data-obcy-opt]').forEach(function (b) {
          b.addEventListener('click', function () {
            st.querySelectorAll('[data-obcy-opt]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            render();
          });
        });
      });
      kit.querySelector('[data-obcy-kit-add]').addEventListener('click', function (e) {
        var btn = e.currentTarget, items = [];
        kit.querySelectorAll('[data-obcy-step]').forEach(function (st) {
          var on = st.querySelector('[aria-pressed="true"][data-v]');
          if (on) items.push({ id: parseInt(on.dataset.v, 10), quantity: 1, properties: { _kit: kit.dataset.obcyKit } });
        });
        if (!items.length) return;
        btn.disabled = true; if (err) err.hidden = true;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { window.location.href = base + 'cart'; })
          .catch(function () { btn.disabled = false; if (err) err.hidden = false; });
      });
      render();
    });
  }

  function init(root) { reveal(root); initSize(root || document); initKit(root || document); deadLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
